// extracted by mini-css-extract-plugin
export default {"topoffer":"TopOffer_topoffer__vtyi-","offerdiv":"TopOffer_offerdiv__wrNgv","offerbutton":"TopOffer_offerbutton__CtHF8","para":"TopOffer_para__R0hdi"};